import React from 'react';
import { Check, X, Trash2 } from 'lucide-react';
import axios from 'axios';
import { API } from '@/api';
import { formatApiError } from '../../utils/apiError';
import { createTextPicker } from '../../utils/localizedContent';


export default function AdminProductReservations({ reservations, setReservations, lang, setMessage }) {
  const l = createTextPicker(lang);
  const handleApprove = async (id) => {
    try {
      await axios.patch(`${API}/product-reservations/admin/${id}/status`, null, { params: { status: 'confirmed' } });
      setReservations(prev => prev.map(r => r.reservation_id === id ? { ...r, status: 'confirmed' } : r));
      setMessage(l('Reserva confirmada', 'Reservation confirmed'));
    } catch (err) {
      setMessage(formatApiError(err));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(l('¿Eliminar esta reserva permanentemente?', 'Delete this reservation permanently?'))) return;
    try {
      await axios.delete(`${API}/product-reservations/admin/${id}`);
      setReservations(prev => prev.filter(r => r.reservation_id !== id));
      setMessage(l('Reserva eliminada', 'Reservation deleted'));
    } catch (err) { setMessage(err.response?.data?.detail || 'Error'); }
  };

  const handleReject = async (id) => {
    try {
      await axios.patch(`${API}/product-reservations/admin/${id}/status`, null, { params: { status: 'cancelled' } });
      setReservations(prev => prev.map(r => r.reservation_id === id ? { ...r, status: 'cancelled' } : r));
      setMessage(l('Reserva cancelada', 'Reservation cancelled'));
    } catch (err) {
      setMessage(formatApiError(err));
    }
  };

  return (
    <div>
      <h2 className="text-white font-bold text-xl mb-4">{l('Reservas de Productos', 'Product Reservations')}</h2>
      <div className="space-y-3">
        {reservations.length === 0 ? (
          <p className="text-[#A1A1AA] text-center py-8">{l('No hay reservas', 'No reservations')}</p>
        ) : reservations.map(r => (
          <div key={r.reservation_id} className="bg-[#12121A] border border-white/5 rounded-xl p-4 flex items-center gap-4" data-testid={`admin-prodres-${r.reservation_id}`}>
            <div className="flex-1">
              <p className="text-white font-semibold">{r.product_name}</p>
              <p className="text-[#A1A1AA] text-sm">{r.user_name || r.user_email} · {r.quantity}x</p>
            </div>
            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${r.status === 'approved' ? 'bg-[#10B981]/20 text-[#34D399]' : r.status === 'rejected' ? 'bg-[#EF4444]/20 text-[#EF4444]' : 'bg-[#F59E0B]/20 text-[#F59E0B]'}`}>{r.status}</span>
            {r.status === 'pending' && (
              <div className="flex gap-1">
                <button onClick={() => handleApprove(r.reservation_id)} className="p-1.5 rounded-lg text-[#10B981] hover:bg-green-500/10" title={l('Confirmar','Confirm')}><Check size={14} /></button>
                <button onClick={() => handleReject(r.reservation_id)} className="p-1.5 rounded-lg text-[#F59E0B] hover:bg-yellow-500/10" title={l('Cancelar','Cancel')}><X size={14} /></button>
              </div>
            )}
            <button onClick={() => handleDelete(r.reservation_id)} className="p-1.5 rounded-lg text-[#EF4444] hover:bg-red-500/10" title={l('Eliminar','Delete')}><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
